import { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { NODE_TYPES } from "../../config.js";
import { Icon } from "../../components/Icon.jsx";

/** Left "Objects" tree: graph nodes grouped by node type. */
export function ObjectsPanel({ nodes, activeId, onSelect }) {
  const [closed, setClosed] = useState({});
  const groups = useMemo(() => {
    const by = new Map();
    for (const n of nodes) {
      if (!by.has(n.type)) by.set(n.type, []);
      by.get(n.type).push(n);
    }
    const order = [...NODE_TYPES, ...[...by.keys()].filter((t) => !NODE_TYPES.includes(t))];
    return order
      .filter((t) => by.has(t))
      .map((t) => ({ type: t, items: by.get(t).sort((a, b) => String(a.label).localeCompare(String(b.label))) }));
  }, [nodes]);

  return (
    <aside className="panel objects-panel">
      <div className="panel-head">
        <Icon name="layers" size={15} />
        <FormattedMessage id="results.objects" />
        <span className="count-chip">{nodes.length}</span>
      </div>
      <div className="panel-scroll">
        {groups.length === 0 ? (
          <p className="muted small pad">
            <FormattedMessage id="results.noObjects" />
          </p>
        ) : null}
        <ul className="tree">
          {groups.map((g) => (
            <li key={g.type}>
              <button
                type="button"
                className="tree-group"
                onClick={() => setClosed((c) => ({ ...c, [g.type]: !c[g.type] }))}
                aria-expanded={!closed[g.type]}
              >
                <Icon name="chevronRight" size={13} className={closed[g.type] ? "" : "rot-90"} />
                <span className={`node-swatch node-${g.type}`} />
                <span className="grow">
                  <FormattedMessage id={`nodeType.${g.type}`} defaultMessage={g.type} />
                </span>
                <span className="count-chip">{g.items.length}</span>
              </button>
              {!closed[g.type] ? (
                <ul>
                  {g.items.map((n) => (
                    <li key={n.id}>
                      <button
                        type="button"
                        className={`tree-item ${activeId === n.id ? "is-active" : ""}`}
                        onClick={() => onSelect(n.id)}
                        title={n.label}
                      >
                        <span className="mono truncate">{n.label}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
